import ExcludeFromLookup from '../../../../../enums/ExcludeFromLookup';
import * as max from '../max-length-validators';

export default {
  name: 'addressNickname',
  label: 'checkout.delivery.address.field.label.address.nickname.text',
  maxLength: 35,
  validate: [max.lengthAddressNickname(35)],
  required: false,
  excludeFromAddressLookup: ExcludeFromLookup.AFTER,
};
